module.exports = __webpack_public_path__ + "static/img/gift_card_popup.36f8ef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/springFestivalActive/light/gift_card_popup.png
// module id = vPj5
// module chunks = 1